/* eslint-disable prettier/prettier */
import Vuex from "vuex";
import Vue from "vue";
import bus from "@/bus";
import store from "@/store";
import { shallowMount, createLocalVue } from "@vue/test-utils";
import GoogleTagManager from "@/plugins/google-tag-manager";

const localVue = createLocalVue();
localVue.use(Vuex);

describe("Google Tag Manager Plugin", () => {
  let Component;
  let wrapper;

  beforeEach(() => {
    bus.$log = {
      info: jest.fn()
    };
    document.getElementsByTagName = jest.fn(() => [
      {
        parentNode: {
          insertBefore: jest.fn()
        }
      }
    ]);
    document.createElement = jest.fn(() => [{}]);

    Component = Vue.component("test-component", {
      data: () => ({}),
      mounted() {},
      template: "<div></div>"
    });

    store.state.openedModal = true;
    store.state.paquetesBeneficios = {
        caracteristicas: {
            tarjetas: [
                {tipoTarjeta: "VISA"}, 
                {tipoTarjeta: "MASTERCARD"}
            ]
        }
    }

    localVue.use(GoogleTagManager);

    wrapper = shallowMount(Component, {
      localVue
    });

    jest.spyOn(wrapper.vm, "gtmOnTextFieldBlur");
    jest.spyOn(wrapper.vm, "gtmOnSelectBlur");
    jest.spyOn(wrapper.vm, "gtmOnCheckboxBlur");
    jest.spyOn(wrapper.vm, "gtmOnLinkClick");
    jest.spyOn(wrapper.vm, "gtmOnSystemError");
    jest.spyOn(wrapper.vm, "gtmOnUserError");
    jest.spyOn(GoogleTagManager, "_gtmPushData");
  });

  afterEach(() => {
    jest.clearAllMocks();
  });

  it("GoogleTagManager gtmOnTextFieldBlur(), gtmOnSelectBlur(), gtmOnCheckboxBlur()", () => {
    const formFieldName = "";
    const formFieldValue = "complete";

    wrapper.vm.gtmOnTextFieldBlur(formFieldName, formFieldValue);
    wrapper.vm.gtmOnSelectBlur(formFieldName, formFieldValue);
    wrapper.vm.gtmOnCheckboxBlur(formFieldName, formFieldValue);

    const gtmOnTextFieldBlurMock = jest.spyOn(wrapper.vm, "gtmOnTextFieldBlur");
    const gtmOnSelectBlurMock = jest.spyOn(wrapper.vm, "gtmOnSelectBlur");
    const gtmOnCheckboxBlurMock = jest.spyOn(wrapper.vm, "gtmOnCheckboxBlur");

    expect(gtmOnTextFieldBlurMock).toHaveBeenCalled();
    expect(gtmOnSelectBlurMock).toHaveBeenCalled();
    expect(gtmOnCheckboxBlurMock).toHaveBeenCalled();
  });

  it("GoogleTagManager gtmOnTextFieldBlur(), gtmOnSelectBlur(), gtmOnCheckboxBlur() formFIeld empty", () => {
    const formFieldName = "";
    const formFieldValue = "";

    store.state.openedModal = false;

    wrapper.vm.gtmOnTextFieldBlur(formFieldName, formFieldValue);
    wrapper.vm.gtmOnSelectBlur(formFieldName, formFieldValue);
    wrapper.vm.gtmOnCheckboxBlur(formFieldName, formFieldValue);

    const gtmOnTextFieldBlurMock = jest.spyOn(wrapper.vm, "gtmOnTextFieldBlur");
    const gtmOnSelectBlurMock = jest.spyOn(wrapper.vm, "gtmOnSelectBlur");
    const gtmOnCheckboxBlurMock = jest.spyOn(wrapper.vm, "gtmOnCheckboxBlur");

    expect(gtmOnTextFieldBlurMock).toHaveBeenCalled();
    expect(gtmOnSelectBlurMock).toHaveBeenCalled();
    expect(gtmOnCheckboxBlurMock).toHaveBeenCalled();
  });

  it("GoogleTagManager gtmOnLinkClick()", () => {
    const uiText = "";
    wrapper.vm.gtmOnLinkClick(uiText);
    const gtmOnLinkClickMock = jest.spyOn(wrapper.vm, "gtmOnLinkClick");
    expect(gtmOnLinkClickMock).toHaveBeenCalled();
  });

  it("GoogleTagManager gtmOnSystemError()", () => {
    const errorMessage = "";
    const errorCode = "";
    wrapper.vm.gtmOnSystemError(errorMessage, errorCode);
    const gtmOnSystemErrorMock = jest.spyOn(wrapper.vm, "gtmOnSystemError");
    expect(gtmOnSystemErrorMock).toHaveBeenCalled();
  });

  it("GoogleTagManager gtmOnSystemError() defaultErrorPlace != null", () => {
    const errorMessage = "";
    const errorCode = "";
    const defaultErrorPlace = "value";
    wrapper.vm.gtmOnSystemError(errorMessage, errorCode, defaultErrorPlace);
    const gtmOnSystemErrorMock = jest.spyOn(wrapper.vm, "gtmOnSystemError");
    expect(gtmOnSystemErrorMock).toHaveBeenCalled();
  });

  it("GoogleTagManager gtmOnUserError()", () => {
    const errorPlace = "";
    const errorMessage = "";
    wrapper.vm.gtmOnUserError(errorPlace, errorMessage);
    const gtmOnUserErrorMock = jest.spyOn(wrapper.vm, "gtmOnUserError");
    expect(gtmOnUserErrorMock).toHaveBeenCalled();
  });

  it("GoogleTagManager busEmit mutationType:ON_ROUTE", () => {
    const mutationObj = {
      mutation: {
        type: "ON_ROUTE",
        payload: {
            meta: {
                config: {
                    pasoAnterior: "default"
                }
            },
            from: {
                name: "default"
            }
        }
      }
    };
    bus.$emit("mutation", mutationObj);
    const gtmPushDataMock = jest.spyOn(GoogleTagManager, "_gtmPushData");
    expect(gtmPushDataMock).not.toHaveBeenCalled();
  });

  it("Configuración exportada por defecto al instalarse", () => {
    expect(wrapper).toBeDefined();
    expect(wrapper).not.toBeNull();
    expect(typeof wrapper).toBe("object");
  });
});